import { AddToCartButton } from './AddToCartButton'

export default AddToCartButton
